import React, { Component } from "react"

export default class Aptitanime extends Component {
  render() {
  return (
    <div className="aptitoptions">
      <a href="https://myanimelist.net/anime/457/Mushishi" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Mushishi</p></a>
      <a href="https://myanimelist.net/anime/28223/Death_Parade" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Death Parade</p></a>
      <a href="https://myanimelist.net/anime/31339/Drifters" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Drifters</p></a>
      <a href="https://myanimelist.net/anime/1454/Kemonozume" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Kemonozume</p></a>
      <a href="https://myanimelist.net/anime/36563/Megalo_Box" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Megalo Box</p></a>
      <a href="https://myanimelist.net/anime/875/Mind_Game" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Mind Game</p></a>
      <a href="https://myanimelist.net/anime/885/Tenshi_no_Tamago" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Angel's Egg</p></a>
      <a href="https://myanimelist.net/anime/6/Trigun" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Trigun</p></a>
      <a href="https://myanimelist.net/profile/hiskneeshurt" target="_blank" rel="noopener noreferrer"><p className="apatitentrypage">&bull; MyAnimeList &bull;</p></a>
    </div>
  )
}
}

